import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import Navigation from '../../components/dashboard/navigation';
import Calendar from '../../components/dashboard/calendar';
import set from 'ember-set-helper/helpers/set';
import { fn } from '@ember/helper';
import { not } from 'ember-truth-helpers';
import split from '../../helpers/split';
<template>
  {{pageTitle " | " (t "general.calendar") prepend=false}}
  <Navigation />
  <Calendar
    @allSchools={{@controller.model.schools}}
    @selectedDate={{@controller.selectedDate}}
    @selectedView={{@controller.selectedView}}
    @mySchedule={{@controller.mySchedule}}
    @showFilters={{@controller.showFilters}}
    @changeDate={{@controller.changeDate}}
    @changeView={{set @controller "view"}}
    @selectEvent={{@controller.selectEvent}}
    @toggleMySchedule={{@controller.toggleMySchedule}}
    @toggleShowFilters={{@controller.toggleShowFilters}}
    @selectedSchool={{@controller.selectedSchool}}
    @changeSchool={{set @controller "school"}}
    @courseFilters={{@controller.courseFilters}}
    @toggleCourseFilters={{fn (set @controller "courseFilters") (not @controller.courseFilters)}}
    @selectedCohortIds={{split "-" @controller.cohorts}}
    @addCohortId={{fn @controller.add "cohorts"}}
    @removeCohortId={{fn @controller.remove "cohorts"}}
    @selectedCourseLevels={{split "-" @controller.courseLevels}}
    @addCourseLevel={{fn @controller.add "courseLevels"}}
    @removeCourseLevel={{fn @controller.remove "courseLevels"}}
    @selectedCourseIds={{split "-" @controller.courses}}
    @addCourseId={{fn @controller.add "courses"}}
    @removeCourseId={{fn @controller.remove "courses"}}
    @selectedSessionTypeIds={{split "-" @controller.sessionTypes}}
    @addSessionTypeId={{fn @controller.add "sessionTypes"}}
    @removeSessionTypeId={{fn @controller.remove "sessionTypes"}}
    @selectedTermIds={{split "-" @controller.terms}}
    @addTermId={{fn @controller.add "terms"}}
    @removeTermId={{fn @controller.remove "terms"}}
    @clearFilters={{@controller.clearFilters}}
  />
</template>
